<template>
  <app-layout></app-layout>
  <language-switcher @language-changed="handleLanguageChange" />
</template>

<script>
import AppLayout from "./components/appLayout.vue";
import LanguageSwitcher from "./components/Shared/LanguageSwitcher.vue";

export default {
  name: "App",
  components: {
    AppLayout,
    LanguageSwitcher
  },
  methods: {
    handleLanguageChange(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('selectedLanguage', lang)
    }
  },
  mounted() {
    // Sayfa yüklendiğinde her zaman Türkçe ile başla
    // Eğer kullanıcı daha önce dil değiştirmişse o dil kullanılır
    const savedLanguage = localStorage.getItem('selectedLanguage')
    if (savedLanguage) {
      this.$i18n.locale = savedLanguage
    } else {
      // İlk kez açılıyorsa Türkçe ile başla
      this.$i18n.locale = 'tr'
      localStorage.setItem('selectedLanguage', 'tr')
    }
  }
};
</script>

